export default __webpack_public_path__ + "static/internal-sales.url-81f01bd181b9f7e570a79cf69298caac.svg";